export default "/images/vendor/flag-icon-css/flags/1x1/xk.svg?082e7027de2c30bf35964eb4f2fd0b68";